import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className = 'h-6 w-6' }) => (
  <span aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
      {/* Background triangle */}
      <path d="M12 3l10 18H2L12 3z" fill="#D6A124" />

      {/* Exclamation line */}
      <line x1="12" y1="9" x2="12" y2="14" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />

      {/* Exclamation dot */}
      <circle cx="12" cy="17" r="1" fill="#FFFFFF" />
    </svg>
  </span>
);

export default Icon;
